module.exports = __webpack_public_path__ + "static/french-cf709a20d119cb4d0ebd8ac98e02d815.jpg";